var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5V1H12.5V9.5H5L2.5 12.5V9.5H1Z",
    stroke: "#3C41B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41309 4.71387H9.11377V5.67627H7.41309V7.36816H6.45068V5.67627H4.75V4.71387H6.45068V3H7.41309V4.71387Z",
    fill: "#3C41B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMessage);
export default __webpack_public_path__ + "static/media/StartMessage.b6c0b09ebc3cc49be143762468c198dd.svg";
export { ForwardRef as ReactComponent };